import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { BlockTitle } from '../styles';
import { CommentTextArea } from './styles';

const LABEL_GUTTER = 28;
const COMMENT_MAX_LENGTH = 500;

interface CommentProps {
	value: string;
	disabled: boolean;
	onChange: (value: string) => void;
	onBlur: () => void;
}

export function Comment({ value, disabled, onChange, onBlur }: Readonly<CommentProps>): JSX.Element {
	function handleChange({ target }: React.ChangeEvent<HTMLTextAreaElement>): void {
		onChange(target.value);
	}

	return (
		<Row gutter={[0, LABEL_GUTTER]}>
			<Col span={24}>
				<BlockTitle>{I18n.get('Comment')}</BlockTitle>
			</Col>
			<Col span={24}>
				<CommentTextArea
					value={value}
					disabled={disabled}
					maxLength={COMMENT_MAX_LENGTH}
					placeholder={I18n.get('Comment')}
					onChange={handleChange}
					onBlur={onBlur}
				/>
			</Col>
		</Row>
	);
}
